<template>
  <div v-zpm="{ sectionid: 175, areaexposure: 175 }" class="model-explanation">
    <div
      v-zpm="{ sortid: 1, sortname: '讲解缩略入口' }"
      class="small"
      :class="{ show: small }"
      @click="jumpToVideo"
    >
      <img :src="$setPicSize('ce583cbf-a4f0-4a0f-8b15-752f8f9b27a6.png')" alt="" class="icon" />
      <div class="desc">看讲解</div>
    </div>
    <div class="normal" :class="{ show, hide: small }">
      <img
        v-zpm="{ sortid: 2, sortname: '关闭' }"
        :src="$setPicSize('844564ec-2bc4-4daf-a8a9-c20e57457469.png')"
        alt=""
        class="close"
        @click="close"
      />
      <div v-zpm="{ sortid: 0, sortname: '机型讲解入口' }" @click="jumpToVideo">
        <video
          ref="videoRef"
          class="video"
          webkit-playsinline=""
          playsinline=""
          x-webkit-airplay="allow"
          x5-video-player-type="h5"
          x5-video-player-fullscreen="false"
          x5-video-orientation="portrait"
          x5-mse-live-streaming=""
          preload
          :loop="true"
          :muted="true"
          :autoplay="true"
          :poster="videoModelSolution.videoImage || ''"
          :src="videoModelSolution.videoUrl"
          @canplay="canplay"
        >
          当前暂不支持H5播放器
        </video>
        <div class="footer">机型讲解</div>
      </div>
    </div>
  </div>
</template>

<script>
import { state } from '@/store'
import { skipToUrl, nativeSetStorage, nativeGetStorage } from '@utils/native'
import { cookie } from '@zz-common/zz-utils'
import { defineComponent, ref, computed } from '@vue/composition-api'

export default defineComponent({
  props: {
    dataInfo: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    // 是否展示 视频
    const show = ref(false)
    // 缩略状态
    const small = ref(
      cookie.get('hide_model_explanation') || nativeGetStorage('hide_model_explanation')
    )
    // 视频信息
    const videoModelSolution = computed(() => {
      return props.dataInfo.videoModelSolution
    })
    // 视频到达能播放的状态
    const canplay = () => {
      show.value = true
    }
    // 关闭函数
    const close = () => {
      small.value = true
      cookie.set('hide_model_explanation', true, { expires: 1 })
      nativeSetStorage('hide_model_explanation', true, 1)
    }
    // 跳转视频地址
    const jumpToVideo = () => {
      const { infoId, metric } = state
      const { installmentInfo = {} } = props.dataInfo
      const payType = installmentInfo?.payType
      const stageId = installmentInfo?.items?.find((item) => item.isDefault)?.term
      const targetUrl = `https://m.zhuanzhuan.com/u/b2c_one_page_bizs/modelExplanationVideo.html?needHideHead=3&infoId=${infoId}&metric=${metric}&payType=${payType}&stageId=${stageId}`
      skipToUrl({
        targetUrl
      })
    }
    return {
      show,
      close,
      canplay,
      small,
      videoModelSolution,
      jumpToVideo
    }
  }
})
</script>

<style lang="scss" scoped>
.model-explanation {
  .normal {
    position: fixed;
    top: 455px;
    right: 24px;
    z-index: 100;
    width: 120px;
    height: 213px;
    overflow: hidden;
    border-radius: 16px;
    transform: scale(0);
    transition: 0.2s;
    &.show {
      transform: scale(1);
    }
    &.hide {
      transform: scale(0);
    }
    .video {
      width: 120px;
      height: 213px;
      object-fit: cover;
    }
    .close {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 1;
      width: 31px;
      height: 31px;
    }
    .footer {
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 1;
      height: 40px;
      color: #111;
      font-weight: 400;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      line-height: 40px;
      text-align: center;
      background: #fff;
      opacity: 0.9;
    }
  }
  .small {
    position: fixed;
    top: 571px;
    right: 24px;
    z-index: 99999999;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 92px;
    height: 97px;
    background: #ffffff;
    border: 0.5px solid #cccccc;
    border-radius: 16px;
    transform: scale(0);
    transition: 0.2s 0.2s;
    &.show {
      transform: scale(1);
    }
    .icon {
      width: 20px;
      height: 21px;
    }
    .desc {
      margin-top: 12px;
      color: #999999;
      font-weight: 400;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      white-space: nowrap;
    }
  }
}
</style>
